class MlDocAssistBot {

    constructor({serverURL, docId, urlId,textColor, themeColor, iconPath}) {
        this.serverURL = serverURL;
        this.docId = docId;
        this.urlId = urlId;
        this.themeColor = themeColor;
        this.textColor = textColor;
        this.iconPath = iconPath;
        this.showBot = false;
        this.answer = "";
        this.errMsg = "";
        // this.dynamicHeight = '420';
        // this.dynamicResultHeight = '255';
        this.question = '';
        this.updateDimension();
        this.updateInnerDimension();
        window.addEventListener('load', () => {
            this.dynamicHeight = '420';
            this.dynamicResultHeight = '255';
        });
        window.addEventListener('resize', () => {
            this.updateDimension(); 
        });
        window.addEventListener('resize', () => {
            this.updateInnerDimension();
        });
    }

    updateDimension() {
        this.dynamicHeight = this.calculateDynamicHeight();
        if (this.chatBotBody) {
            this.chatBotBody.style.height = this.dynamicHeight;
        }
    }
    updateInnerDimension() {
        this.dynamicResultHeight = this.calculateInnerDynamicHeight();
        this.assignResultPanelHeight();
    }

    calculateDynamicHeight() {
        if (window.innerWidth < 1396) {
          return window.innerHeight - 185 + 'px'; // Calculate a new height
        }
    }

    calculateInnerDynamicHeight() {
        if (window.innerWidth < 1396) { 
            return window.innerHeight - 350 + 'px'; // Calculate a new height
        } 
    }

    initBot() {
        let link = document.createElement("link");
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css'
        document.querySelector('head').appendChild(link);

        const floatingElement = document.createElement('label');
        floatingElement.className = 'chat_button ml-chart_icon_position';
        floatingElement.style.background = this.themeColor; 

        const closeIcon = '<svg alt="close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" height="25px" width="25px" role="img" className="tawk-min-chat-icon"> <path fillRule="evenodd" clipRule="evenodd" d="M466.24042,400.4053l272.927-275.99463c6.94586-8.76452,11.13092-20.00501,11.13092-32.20959 s-4.18506-23.42317-11.21857-32.29724l0.08765,0.10955c-8.76453-6.94588-20.005-11.13094-32.20959-11.13094 c-12.20453,0-23.42316,4.18505-32.29724,11.21858l0.10956-0.08765L401.84311,336.008L125.84851,60.0134 c-8.76452-6.94588-20.00501-11.13094-32.2096-11.13094s-23.42316,4.18506-32.29724,11.21858l0.10955-0.08765 C54.50535,68.77792,50.32029,80.01842,50.32029,92.223s4.18505,23.42317,11.21858,32.29724l-0.08764-0.10956l275.9946,275.99463 L61.45122,673.33234c-6.94588,8.76453-11.13094,20.005-11.13094,32.20959s4.18506,23.42316,11.21858,32.29724l-0.08765-0.1095 c8.19483,7.64703,19.2162,12.33606,31.33314,12.33606c0.83263,0,1.68717-0.02191,2.49789-0.06573h-0.10957 c0.54779,0.02191,1.20512,0.04382,1.86246,0.04382c11.32813,0,21.5388-4.71094,28.79144-12.29224l0.0219-0.02191 l275.99463-272.92703l272.92703,272.92703c7.2746,7.58136,17.48523,12.31415,28.81335,12.31415 c0.65735,0,1.29279-0.02191,1.95013-0.04382h-0.08765c0.72308,0.04382,1.55573,0.06573,2.38831,0.06573 c12.11694,0,23.16022-4.68903,31.37695-12.35797l-0.02185,0.02191c6.94586-8.76447,11.13092-20.005,11.13092-32.20959 c0-12.20453-4.18506-23.42316-11.21857-32.29724l0.08765,0.10956L466.24042,400.4053z"></path></svg >';
        const botIcon = '<svg alt="open" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" height="32px" width="32px" role="img" className="tawk-min-chat-icon" > <path fillRule="evenodd" clipRule="evenodd" d="M400 26.2c-193.3 0-350 156.7-350 350 0 136.2 77.9 254.3 191.5 312.1 15.4 8.1 31.4 15.1 48.1 20.8l-16.5 63.5c-2 7.8 5.4 14.7 13 12.1l229.8-77.6c14.6-5.3 28.8-11.6 42.4-18.7C672 630.6 750 512.5 750 376.2c0-193.3-156.7-350-350-350zm211.1 510.7c-10.8 26.5-41.9 77.2-121.5 77.2-79.9 0-110.9-51-121.6-77.4-2.8-6.8 5-13.4 13.8-11.8 76.2 13.7 147.7 13 215.3.3 8.9-1.8 16.8 4.8 14 11.7z"></path></svg >'
        floatingElement.innerHTML = this.showBot ? closeIcon : botIcon;
        // Add click event listener to remove the element when clicked
        floatingElement.addEventListener('click', () => {
            this.showBot = !this.showBot;
            floatingElement.innerHTML = this.showBot ? closeIcon : botIcon;

            if(this.showBot) {
                this.showInputContainer()
            }
            else {
                this.removeInputContainer();
            }
        });
        
        // Append the element to the body
        document.body.appendChild(floatingElement);
    }

    showInputContainer() { 
        this.chatBot = document.createElement('div');
        this.chatBot.className = 'ml-chat-bot';
        this.chatBotHeader = document.createElement('div')
        this.chatBotHeader.className = 'ml-chat-bot-header'
        this.chatBotHeader.style.background = this.themeColor; 
        this.chatBotHeader.innerHTML = `<img src=${this.iconPath ? this.iconPath : 'default-logo.svg'} alt="Logo" />`;
        this.chatBot.appendChild(this.chatBotHeader)
        const searchArrow = 'arrow_icon.png';
        this.chatBotBody = document.createElement('div')
        this.chatBotBody.className = 'ml-chat-bot-body';
        this.chatBotBody.style.height = this.dynamicHeight;
        this.chatBotBody.innerHTML = `
            <div>
                <label>Ask me a question</label>
            </div>
            <div class="positionRelative mar-top5">
                <input placeholder="Type your question" type="text" class="ml-form-control input" value="${this.question}"/>
                <button alt="log" class="ml-action_arrow"> 
                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                        width="20pt" height="16pt" viewBox="0 0 20 20"
                        preserveAspectRatio="xMidYMid meet">
                    
                        <g transform="translate(0.000000,22) scale(0.100000,-0.100000)"
                        fill="#666666" stroke="none">
                        <path d="M50 161 c0 -27 3 -29 58 -38 l57 -9 -57 -8 c-55 -7 -58 -9 -58 -36
                        l0 -29 82 35 c45 19 84 37 86 38 2 3 -38 21 -135 63 -33 13 -33 13 -33 -16z"/>
                        </g>
                    </svg>
                </button>
            </div>
        `;

        

        this.chatBot.appendChild(this.chatBotBody);

        this.loaderImg = document.createElement('div');
    
        this.resultContainer =  document.createElement('div');
        this.resultContainer.className = 'ml_show_result';
        this.resultContainer.style.background = this.themeColor;
        this.resultContainer.style.color = this.textColor;


        this.errorContainer = document.createElement('div');
        this.errorContainer.className = 'show_error';

        document.body.appendChild(this.chatBot);

        let input = document.querySelector('.input');

        input.addEventListener('input', (evt) => {
            // console.log('evt', evt.target.value);
            this.hideResult();
            this.question = evt.target.value;
        });

        input.addEventListener("keydown", (event) => {
            // console.log('event.keyCode', event.keyCode);
            if (event.isComposing || event.keyCode === 229) {
                return;
            }
            if (event.keyCode === 13) {
                this.fetchAnswer();
            }
        });


        const submitArrow = document.querySelector('.ml-action_arrow');
        submitArrow.addEventListener('click', (evt) => {
            this.fetchAnswer();
        });
    }

    showParameterError(param) {
        this.hideResult()
        this.showError();
        this.errMsg = param + ' parameter is required';
    }


    fetchAnswer() {
        this.hideResult();
        if (!this.serverURL) {
          this.showParameterError('serverURL')
          return;
        }
        if (!this.docId && !this.urlId) {
          this.showParameterError('docId')
          return
        }
        if (!this.question || this.question.trim().length === 0) {
          return
        }
        const payload = {
          question: this.question,
        }
    
        if (this.docId) {
          payload['doc_id'] = this.docId;
        }
        else if (this.urlId) {
          payload['url_id'] = this.urlId;
        }
        
    
        this.getAnswer(this.serverURL, payload).then(data => { 
            this.hideLoader();
            this.answer = data.answer;
            this.showResult();
            
        }).catch(err => {
            this.hideResult();
            this.hideLoader();
            this.errMsg = err;
            this.showError();
        })
    }

    getAnswer(serverURL, payload) {
        this.showLoader();
        const baseUrl = serverURL + "/q_and_a/enquire";
        return fetch(baseUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(res => res.json());
    }

    assignResultPanelHeight(){
        if(document.getElementsByClassName('ml_inner_panel').length > 0){
            document.getElementsByClassName('ml_inner_panel')[0].style.maxHeight = this.dynamicResultHeight;
        }
    }

    showResult() { 
        this.resultContainer.innerHTML = `
            <div class="ml_inner_panel" style="max-height: ${this.dynamicResultHeight}">
            <pre style="color: ${this.textColor}">${this.answer}</pre>
            </div>
        `;
        this.chatBotBody.appendChild(this.resultContainer);
    }

    hideResult() {
        const show_result = document.querySelector('.ml_show_result');
        if (show_result) {
            this.chatBotBody.removeChild(this.resultContainer);
        }
    }
    

    showLoader() { 
        this.loaderImg.innerHTML = '<i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>'
        this.loaderImg.className = 'ml-loader';
        this.chatBotBody.appendChild(this.loaderImg);
    }

    hideLoader() {
        this.chatBotBody.removeChild(this.loaderImg);
    }

    showError() {
        this.errorContainer.innerHTML = `
            <div class="ml_inner_error" style="max-height: ${this.dynamicResultHeight}">
                <p>
                    <i className="fa fa-times-circle"></i> ${this.errMsg}
                </p>
            </div >
        `;
        this.chatBotBody.appendChild(this.errorContainer);
    }

    hideError() {
        this.chatBotBody.removeChild(this.errorContainer);
    }

    removeInputContainer() {
        document.body.removeChild(this.chatBot);
    }

}

export default MlDocAssistBot;